<template>
    <!-- wrap -->
    <div id="wrap">
        <!-- header -->
        <div id="header">
            <div class="container">
                <div class="header-top">
                    <div class="back">
                        <a @click="backbtn"><i /><span class="blind">뒤로가기</span></a>
                        <span class="header-sub">( NATM ) </span><span> 페이스매핑 상세</span>
                    </div>

                    <div class="header-nav">
                        <a class="btn btn-home" @click="home"><i /><span class="blind">홈으로</span></a>
                    </div>
                </div>
            </div>
        </div>
        <!-- // header -->

        <!-- content-wrap -->
        <main id="content-wrap">
            <div id="contents">
                <div class="detail-wrapper">
                    <div v-if="data.approveState !== 'request'" class="detail-box" :class="{ close: isCloseE }">
                        <div class="detail-header">
                            <a class="view" :class="{ close: isCloseE }" @click="isCloseE = !isCloseE">
                                <span>결재현황</span>
                            </a>
                        </div>
                        <div class="detail-contents">
                            <div class="detail-subheader">
                                <table class="type-simple">
                                    <thead>
                                        <tr>
                                            <th v-for="(item, index) in approvalList" :key="index">
                                                {{ index === 0 ? '기록자' : '확인자' }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td v-for="(item, index) in approvalList" :key="index">
                                                <span>{{ displayApproval(item) }}</span>
                                                <img
                                                    v-if="item.status === 'approval'"
                                                    :src="item.signUrl"
                                                    height="50px"
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="content-box">
                            <button v-if="isSignCancelBtn" class="btn btn-sign-cancel" @click="signCancel()">
                                <span>서명취소</span>
                            </button>
                            <button v-if="isSignBtn" class="btn btn-sign" @click="sign()">
                                <span>서명하기</span>
                            </button>
                        </div>
                    </div>

                    <div class="detail-box" :class="{ close: isCloseA }">
                        <div class="detail-header">
                            <a class="view" :class="{ close: isCloseA }" @click="isCloseA = !isCloseA">
                                <span>막장평가표</span>
                            </a>
                        </div>
                        <div class="detail-contents">
                            <ul class="fms-note">
                                <li>
                                    <span>Const. Name</span>
                                    <span>{{ data.constructionNameValue }}</span>
                                </li>
                                <li>
                                    <span>Geologist</span>
                                    <span>{{ data.geologist }}</span>
                                </li>
                                <li>
                                    <span>Tunnel Name</span>
                                    <span>{{ data.measureLocationName }}</span>
                                </li>
                                <li>
                                    <span>Date</span>
                                    <span>{{ data.investigationDay }}</span>
                                </li>
                                <li>
                                    <span>Station</span>
                                    <span>STA NO. {{ data.station }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="detail-box" :class="{ close: isCloseB }">
                        <div class="detail-header">
                            <a class="view" :class="{ close: isCloseB }" @click="isCloseB = !isCloseB">
                                <span>막장 매핑</span>
                            </a>
                        </div>
                        <div class="detail-contents">
                            <div v-if="data.threeDimensionalImageUrl" class="detail-img-box">
                                <span>{{ data.bearing }}</span>
                                <img v-gallery:detail :src="data.rockJudgmentImageUrl" />
                            </div>
                            <div v-else class="detail-noImg-box">
                                <span>{{ data.bearing }}</span>
                                사진없음
                            </div>

                            <div class="detail-subheader">
                                <h3>특기사항</h3>
                                <pre>{{ data.description }}</pre>
                            </div>
                            <div class="detail-subheader">
                                <h3>굴착현황</h3>
                                <pre>{{ data.faultShearZone }}</pre>
                            </div>
                        </div>
                    </div>

                    <div class="detail-box" :class="{ close: isCloseC }">
                        <div class="detail-header">
                            <a class="view" :class="{ close: isCloseC }" @click="isCloseC = !isCloseC">
                                <span>막장 평가표</span>
                            </a>
                        </div>
                        <div class="detail-contents">
                            <ul class="fms-note">
                                <li>
                                    <span>터널명</span>
                                    <span>{{ data.measureLocationName }}</span>
                                </li>
                                <li>
                                    <span>위치</span>
                                    <span>STA NO. {{ data.station }}</span>
                                </li>
                                <li>
                                    <span>일자</span>
                                    <span>{{ data.investigationDay }}</span>
                                </li>
                                <li>
                                    <span>관찰자</span>
                                    <span>{{ data.geologist }}</span>
                                </li>
                                <li>
                                    <span>Rock Type</span>
                                    <span>{{ data.rockType }}</span>
                                </li>
                            </ul>

                            <div class="detail-subheader">
                                <h3>
                                    ⓛ
                                    <span class="val">
                                        점수 : {{ 16 - faceMappingStrength.strengthIntackRockMaterialScore }}
                                    </span>
                                </h3>

                                <table class="type-simple">
                                    <thead>
                                        <tr>
                                            <th colspan="2">
                                                점하중강도
                                            </th>
                                            <th>10이상</th>
                                            <th colspan="5">
                                                4 - 10
                                            </th>
                                        </tr>
                                        <tr>
                                            <th colspan="2">
                                                슈미트햄머
                                            </th>
                                            <th>60이상</th>
                                            <th colspan="5">
                                                51-60
                                            </th>
                                        </tr>
                                        <tr>
                                            <th colspan="2">
                                                일축압축강도
                                            </th>
                                            <th>250이상</th>
                                            <th colspan="5">
                                                100-250
                                            </th>
                                        </tr>
                                        <tr>
                                            <th colspan="2">
                                                점수
                                            </th>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.strengthIntackRockMaterialScore === 1"
                                                    src="/images/report/check.png"
                                                />15
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.strengthIntackRockMaterialScore === 2"
                                                    src="/images/report/check.png"
                                                />14
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.strengthIntackRockMaterialScore === 3"
                                                    src="/images/report/check.png"
                                                />13
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.strengthIntackRockMaterialScore === 4"
                                                    src="/images/report/check.png"
                                                />12
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.strengthIntackRockMaterialScore === 5"
                                                    src="/images/report/check.png"
                                                />11
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.strengthIntackRockMaterialScore === 6"
                                                    src="/images/report/check.png"
                                                />10
                                            </td>
                                        </tr>
                                    </thead>
                                </table>
                                <table class="type-simple">
                                    <thead>
                                        <tr>
                                            <th colspan="2">
                                                점하중강도
                                            </th>
                                            <th colspan="4">
                                                2 - 4
                                            </th>
                                            <th colspan="2">
                                                1 - 2
                                            </th>
                                        </tr>
                                        <tr>
                                            <th colspan="2">
                                                슈미트햄머
                                            </th>
                                            <th colspan="4">
                                                44 - 51
                                            </th>
                                            <th colspan="2">
                                                34-44
                                            </th>
                                        </tr>
                                        <tr>
                                            <th colspan="2">
                                                일축압축강도
                                            </th>
                                            <th colspan="4">
                                                50 - 100
                                            </th>
                                            <th colspan="2">
                                                25-50
                                            </th>
                                        </tr>
                                        <tr>
                                            <th colspan="2">
                                                -
                                            </th>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.strengthIntackRockMaterialScore === 7"
                                                    src="/images/report/check.png"
                                                />9
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.strengthIntackRockMaterialScore === 8"
                                                    src="/images/report/check.png"
                                                />8
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.strengthIntackRockMaterialScore === 9"
                                                    src="/images/report/check.png"
                                                />7
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.strengthIntackRockMaterialScore === 10"
                                                    src="/images/report/check.png"
                                                />6
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.strengthIntackRockMaterialScore === 11"
                                                    src="/images/report/check.png"
                                                />5
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.strengthIntackRockMaterialScore === 12"
                                                    src="/images/report/check.png"
                                                />4
                                            </td>
                                        </tr>
                                        <tr>
                                            <th colspan="2">
                                                일일압축강도
                                            </th>
                                            <th colspan="2">
                                                5 - 25
                                            </th>
                                            <th colspan="2">
                                                1 - 5
                                            </th>
                                            <th colspan="2">
                                                1 미만
                                            </th>
                                        </tr>
                                        <tr>
                                            <th colspan="2">
                                                -
                                            </th>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.strengthIntackRockMaterialScore === 13"
                                                    src="/images/report/check.png"
                                                />3
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.strengthIntackRockMaterialScore === 14"
                                                    src="/images/report/check.png"
                                                />2
                                            </td>
                                            <td colspan="2">
                                                <img
                                                    v-if="faceMappingStrength.strengthIntackRockMaterialScore === 15"
                                                    src="/images/report/check.png"
                                                />1
                                            </td>
                                            <td colspan="2">
                                                <img
                                                    v-if="faceMappingStrength.strengthIntackRockMaterialScore === 16"
                                                    src="/images/report/check.png"
                                                />0
                                            </td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>

                            <div class="detail-subheader">
                                <h3>
                                    ② 암질계수(%)
                                    <span class="val"> 점수 : {{ 21 - faceMappingStrength.rqdScore }} </span>
                                </h3>
                                <table class="type-simple">
                                    <thead>
                                        <tr>
                                            <th colspan="3">
                                                90~100
                                            </th>
                                            <th colspan="3">
                                                75~90
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.rqdScore === 1"
                                                    src="/images/report/check.png"
                                                />20
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.rqdScore === 2"
                                                    src="/images/report/check.png"
                                                />19
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.rqdScore === 3"
                                                    src="/images/report/check.png"
                                                />18
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.rqdScore === 4"
                                                    src="/images/report/check.png"
                                                />17
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.rqdScore === 5"
                                                    src="/images/report/check.png"
                                                />16
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.rqdScore === 6"
                                                    src="/images/report/check.png"
                                                />15
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table class="type-simple">
                                    <thead>
                                        <tr>
                                            <th colspan="5">
                                                50~75
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.rqdScore === 7"
                                                    src="/images/report/check.png"
                                                />14
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.rqdScore === 8"
                                                    src="/images/report/check.png"
                                                />13
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.rqdScore === 9"
                                                    src="/images/report/check.png"
                                                />12
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.rqdScore === 10"
                                                    src="/images/report/check.png"
                                                />11
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.rqdScore === 11"
                                                    src="/images/report/check.png"
                                                />10
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table class="type-simple">
                                    <thead>
                                        <tr>
                                            <th colspan="6">
                                                25-50
                                            </th>
                                            <th>
                                                25미만
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.rqdScore === 12"
                                                    src="/images/report/check.png"
                                                />9
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.rqdScore === 13"
                                                    src="/images/report/check.png"
                                                />8
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.rqdScore === 14"
                                                    src="/images/report/check.png"
                                                />7
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.rqdScore === 15"
                                                    src="/images/report/check.png"
                                                />6
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.rqdScore === 16"
                                                    src="/images/report/check.png"
                                                />5
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.rqdScore === 17"
                                                    src="/images/report/check.png"
                                                />4
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.rqdScore === 18"
                                                    src="/images/report/check.png"
                                                />3
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="detail-subheader">
                                <h3>
                                    ③ 절리면 간격
                                    <span class="val"> 점수 : {{ 21 - faceMappingStrength.spacingJoinScore }} </span>
                                </h3>
                                <table class="type-simple">
                                    <thead>
                                        <tr>
                                            <th colspan="2">
                                                2m이상
                                            </th>
                                            <th colspan="8">
                                                0.6-2m
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colspan="2">
                                                <img
                                                    v-if="faceMappingStrength.spacingJoinScore === 1"
                                                    src="/images/report/check.png"
                                                />20
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.spacingJoinScore === 2"
                                                    src="/images/report/check.png"
                                                />19
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.spacingJoinScore === 3"
                                                    src="/images/report/check.png"
                                                />18
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.spacingJoinScore === 4"
                                                    src="/images/report/check.png"
                                                />17
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.spacingJoinScore === 5"
                                                    src="/images/report/check.png"
                                                />16
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.spacingJoinScore === 6"
                                                    src="/images/report/check.png"
                                                />15
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.spacingJoinScore === 7"
                                                    src="/images/report/check.png"
                                                />14
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.spacingJoinScore === 8"
                                                    src="/images/report/check.png"
                                                />13
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.spacingJoinScore === 9"
                                                    src="/images/report/check.png"
                                                />12
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table class="type-simple">
                                    <thead>
                                        <tr>
                                            <th colspan="4">
                                                0.2-0.6m
                                            </th>
                                            <th colspan="2">
                                                6-20cm
                                            </th>
                                            <th colspan="2">
                                                6cm미만
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.spacingJoinScore === 10"
                                                    src="/images/report/check.png"
                                                />11
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.spacingJoinScore === 11"
                                                    src="/images/report/check.png"
                                                />10
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.spacingJoinScore === 12"
                                                    src="/images/report/check.png"
                                                />9
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.spacingJoinScore === 13"
                                                    src="/images/report/check.png"
                                                />8
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.spacingJoinScore === 14"
                                                    src="/images/report/check.png"
                                                />7
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.spacingJoinScore === 15"
                                                    src="/images/report/check.png"
                                                />6
                                            </td>
                                            <td colspan="2">
                                                <img
                                                    v-if="faceMappingStrength.spacingJoinScore === 16"
                                                    src="/images/report/check.png"
                                                />5
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="detail-subheader">
                                <h3>
                                    ④ 절리면 상태
                                    <span class="val"> 점수 : {{ faceMappingStrength.conditionJoinScore }} </span>
                                </h3>
                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: 15%" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th rowspan="2">불연속면의 길이<br />(연속성)</th>
                                            <th>1m 미만<br />6</th>
                                            <th>1-3m<br />4</th>
                                            <th>3-10m<br />2</th>
                                            <th>10-20m<br />1</th>
                                            <th>20m 이상<br />0</th>
                                        </tr>
                                        <tr>
                                            <td style="height: 30px;">
                                                <img
                                                    v-if="sectionList.persitence === '1'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                            <td>
                                                <img
                                                    v-if="sectionList.persitence === '2'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                            <td>
                                                <img
                                                    v-if="sectionList.persitence === '3'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                            <td>
                                                <img
                                                    v-if="sectionList.persitence === '4'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                            <td>
                                                <img
                                                    v-if="sectionList.persitence === '5'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                        </tr>
                                    </thead>
                                </table>
                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: 15%" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th rowspan="2">불연속면의 간격<br />(틈새)</th>
                                            <th>없음<br />6</th>
                                            <th><span class="small-font">0.1mm 이하</span><br />5</th>
                                            <th><span class="small-font">0.1-1.0mm</span><br />4</th>
                                            <th>1-5mm<br />1</th>
                                            <th>5mm 이상<br />0</th>
                                        </tr>
                                        <tr>
                                            <td style="height: 30px;">
                                                <img
                                                    v-if="sectionList.aperture === '1'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                            <td>
                                                <img
                                                    v-if="sectionList.aperture === '2'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                            <td>
                                                <img
                                                    v-if="sectionList.aperture === '3'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                            <td>
                                                <img
                                                    v-if="sectionList.aperture === '4'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                            <td>
                                                <img
                                                    v-if="sectionList.aperture === '5'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                        </tr>
                                    </thead>
                                </table>
                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: 15%" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th rowspan="2">
                                                거칠기
                                            </th>
                                            <th>매우 거침<br />6</th>
                                            <th>거침<br />6</th>
                                            <th>약간 거침<br />3</th>
                                            <th>매끄러움<br />1</th>
                                            <th><span class="small-font">단층마찰면</span><br />0</th>
                                        </tr>
                                        <tr>
                                            <td style="height: 30px;">
                                                <img
                                                    v-if="sectionList.roughness === '1'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                            <td>
                                                <img
                                                    v-if="sectionList.roughness === '2'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                            <td>
                                                <img
                                                    v-if="sectionList.roughness === '3'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                            <td>
                                                <img
                                                    v-if="sectionList.roughness === '4'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                            <td>
                                                <img
                                                    v-if="sectionList.roughness === '5'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                        </tr>
                                    </thead>
                                </table>
                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: 15%" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th rowspan="3">
                                                충전물
                                            </th>
                                            <th rowspan="2">없음<br />6</th>
                                            <th colspan="2">
                                                단단한 충전물
                                            </th>
                                            <th colspan="2">
                                                연약한 충전물
                                            </th>
                                        </tr>
                                        <tr>
                                            <th>
                                                <span class="small-font">5mm 미만<br />4</span>
                                            </th>
                                            <th>
                                                <span class="small-font">5mm 이상<br />2</span>
                                            </th>
                                            <th>
                                                <span class="small-font">5mm 미만<br />2</span>
                                            </th>
                                            <th>
                                                <span class="small-font">5mm 이상<br />0</span>
                                            </th>
                                        </tr>
                                        <tr>
                                            <td style="height: 30px;">
                                                <img
                                                    v-if="sectionList.inFilling === '1'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                            <td>
                                                <img
                                                    v-if="sectionList.inFilling === '2'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                            <td>
                                                <img
                                                    v-if="sectionList.inFilling === '3'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                            <td>
                                                <img
                                                    v-if="sectionList.inFilling === '4'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                            <td>
                                                <img
                                                    v-if="sectionList.inFilling === '5'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                        </tr>
                                    </thead>
                                </table>
                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: 15%" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th rowspan="2">
                                                풍화정도
                                            </th>
                                            <th>풍화안됨<br />6</th>
                                            <th>약간 풍화<br />5</th>
                                            <th>풍화<br />3</th>
                                            <th>심한 풍화<br />1</th>
                                            <th><span class="small-font">파쇄(완전풍화)</span><br />0</th>
                                        </tr>
                                        <tr>
                                            <td style="height: 30px;">
                                                <img
                                                    v-if="sectionList.wallStrength === '1'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                            <td>
                                                <img
                                                    v-if="sectionList.wallStrength === '2'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                            <td>
                                                <img
                                                    v-if="sectionList.wallStrength === '3'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                            <td>
                                                <img
                                                    v-if="sectionList.wallStrength === '4'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                            <td>
                                                <img
                                                    v-if="sectionList.wallStrength === '5'"
                                                    src="/images/report/check.png"
                                                />
                                            </td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>

                            <div class="detail-subheader">
                                <h3>
                                    ⑤ 지하수
                                    <span class="val">점수 : {{ waterScore() }}</span>
                                </h3>

                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: 15%" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>0m당<br />유입량</th>
                                            <th>없음</th>
                                            <th>10 (L/min)</th>
                                            <th>10-25(L/min)</th>
                                            <th>25-125(L/min)</th>
                                            <th>125초과(L/min)</th>
                                        </tr>
                                        <tr>
                                            <th>절리수압/<br />최대주응력</th>
                                            <th>0</th>
                                            <th>0.1미만</th>
                                            <th>0.1-0.2</th>
                                            <th>0.2-0.5</th>
                                            <th>0.5초과</th>
                                        </tr>
                                        <tr>
                                            <th>일반조건</th>
                                            <th>완전 건조</th>
                                            <th>습윤</th>
                                            <th>젖어 있음</th>
                                            <th><span class="small-font">물방울 떨어짐</span></th>
                                            <th>물이 흐름</th>
                                        </tr>
                                        <tr>
                                            <th style="height: 30px;">
                                                점수
                                            </th>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.groundWaterRatioScore === 1"
                                                    src="/images/report/check.png"
                                                />15
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.groundWaterRatioScore === 2"
                                                    src="/images/report/check.png"
                                                />10
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.groundWaterRatioScore === 3"
                                                    src="/images/report/check.png"
                                                />7
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.groundWaterRatioScore === 4"
                                                    src="/images/report/check.png"
                                                />4
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.groundWaterRatioScore === 5"
                                                    src="/images/report/check.png"
                                                />0
                                            </td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>

                            <div class="detail-subheader">
                                <h3>
                                    ⑥ 절리방향에 따른 보정
                                    <span class="val">점수 : {{ orientationScore() }}</span>
                                </h3>

                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: 15%" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th rowspan="3">
                                                충전물
                                            </th>
                                            <th colspan="4">
                                                주향이 터널방향과 수직
                                            </th>
                                            <th colspan="2" rowspan="2">
                                                주향이 터널 진행방향과 평행
                                            </th>
                                            <th rowspan="2">
                                                주향과 무관
                                            </th>
                                        </tr>
                                        <tr>
                                            <th colspan="2">
                                                경사방향 굴진
                                            </th>
                                            <th colspan="2">
                                                역경사 방향 굴진
                                            </th>
                                        </tr>
                                        <tr>
                                            <td>45-90°</td>
                                            <td>20-45°</td>
                                            <td>45-90°</td>
                                            <td>20-45°</td>
                                            <td>45-90°</td>
                                            <td>20-45°</td>
                                            <td>0-20°</td>
                                        </tr>
                                        <tr>
                                            <th style="height: 30px;">
                                                점수
                                            </th>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.orientationScore === 1"
                                                    src="/images/report/check.png"
                                                />0
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.orientationScore === 2"
                                                    src="/images/report/check.png"
                                                />
                                                - 2
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.orientationScore === 3"
                                                    src="/images/report/check.png"
                                                />- 5
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.orientationScore === 4"
                                                    src="/images/report/check.png"
                                                />- 10
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.orientationScore === 5"
                                                    src="/images/report/check.png"
                                                />- 12
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.orientationScore === 6"
                                                    src="/images/report/check.png"
                                                />- 5
                                            </td>
                                            <td>
                                                <img
                                                    v-if="faceMappingStrength.orientationScore === 7"
                                                    src="/images/report/check.png"
                                                />- 5
                                            </td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            <div class="detail-subheader">
                                <h3>암판 평가</h3>
                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: 15%" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>
                                                RMR 평점
                                            </th>
                                            <td>100 - 81</td>
                                            <td>80 - 61</td>
                                            <td>60 - 41</td>
                                            <td>40 - 21</td>
                                            <td>20</td>
                                            <td>비고</td>
                                        </tr>
                                        <tr>
                                            <th>
                                                암반상태
                                            </th>
                                            <td>매우우수</td>
                                            <td>우 수</td>
                                            <td>양 호</td>
                                            <td>불 량</td>
                                            <td>매우불량</td>
                                            <td />
                                        </tr>
                                        <tr>
                                            <th>
                                                TYPE
                                            </th>
                                            <td>
                                                <img
                                                    v-if="displayType(faceMappingStrength.rmrScore) === 1"
                                                    src="/images/report/check.png"
                                                />Ⅰ
                                            </td>
                                            <td>
                                                <img
                                                    v-if="displayType(faceMappingStrength.rmrScore) === 2"
                                                    src="/images/report/check.png"
                                                />Ⅱ
                                            </td>
                                            <td>
                                                <img
                                                    v-if="displayType(faceMappingStrength.rmrScore) === 3"
                                                    src="/images/report/check.png"
                                                />Ⅲ
                                            </td>
                                            <td>
                                                <img
                                                    v-if="displayType(faceMappingStrength.rmrScore) === 4"
                                                    src="/images/report/check.png"
                                                />Ⅳ
                                            </td>
                                            <td>
                                                <img
                                                    v-if="displayType(faceMappingStrength.rmrScore) === 5"
                                                    src="/images/report/check.png"
                                                />Ⅴ
                                            </td>
                                            <td />
                                        </tr>
                                    </thead>
                                </table>
                            </div>

                            <div class="detail-subheader">
                                <h3>8. RMR Score</h3>
                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: 15%" />
                                        <col style="width: auto" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>총점</th>
                                            <td>{{ faceMappingStrength.rmrScore }}</td>
                                            <th>TYPE 결정</th>
                                            <td>{{ data.decisionRockType }}</td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="detail-box" :class="{ close: isCloseD }">
                        <div class="detail-header">
                            <a class="view" :class="{ close: isCloseD }" @click="isCloseD = !isCloseD">
                                <span>막장 사진대지</span>
                            </a>
                        </div>
                        <div class="detail-contents">
                            <div class="photo-list-wrapper">
                                <div class="photo-list-box">
                                    <p class="tit">
                                        천단부
                                    </p>
                                    <div class="photo-inbox-wrapper">
                                        <div class="photo-inbox ratio-type-1">
                                            <div v-if="data.topImageUrl" class="photo-img">
                                                <img v-gallery:detail :src="data.topImageUrl" :alt="data.topImageUrl" />
                                            </div>
                                            <div v-else class="detail-noImg-box">
                                                사진없음
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="photo-list-box">
                                    <p class="tit">
                                        막장면
                                    </p>
                                    <div class="photo-inbox-wrapper">
                                        <div class="photo-inbox ratio-type-1">
                                            <div v-if="data.frontImageUrl" class="photo-img height">
                                                <img :src="data.frontImageUrl" :alt="data.frontImageUrl" />
                                            </div>
                                            <div v-else class="detail-noImg-box">
                                                사진없음
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="photo-list-box cnt-2">
                                    <p class="tit">
                                        좌측면
                                    </p>
                                    <div class="photo-inbox-wrapper cnt-2">
                                        <div class="photo-inbox ratio-type-2">
                                            <div v-if="data.leftImageUrl" class="photo-img height">
                                                <img
                                                    v-gallery:detail
                                                    :src="data.leftImageUrl"
                                                    :alt="data.leftImageUrl"
                                                />
                                            </div>
                                            <div v-else class="detail-noImg-box">
                                                사진없음
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="photo-list-box cnt-2">
                                    <p class="tit">
                                        우측면
                                    </p>
                                    <div class="photo-inbox-wrapper cnt-2">
                                        <div class="photo-inbox ratio-type-2">
                                            <div v-if="data.rightImageUrl" class="photo-img height">
                                                <img
                                                    v-gallery:detail
                                                    :src="data.rightImageUrl"
                                                    :alt="data.rightImageUrl"
                                                />
                                            </div>
                                            <div v-else class="detail-noImg-box">
                                                사진없음
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="detail-box comment-box">
                        <div class="detail-contents">
                            <div class="detail-subheader">
                                <h3>Comment</h3>
                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: auto;" />
                                        <col style="width: 60px;" />
                                    </colgroup>
                                    <tr>
                                        <td>
                                            <textarea
                                                v-model="comment"
                                                class="comment"
                                                placeholder="댓글을 입력해주세요"
                                            />
                                        </td>
                                        <td>
                                            <button class="btn btn-confirm" @click="addComment()">
                                                <span>등록</span>
                                            </button>
                                        </td>
                                    </tr>
                                </table>

                                <span class="comment-count">총 {{ commentList.length }}개의 댓글이 있습니다.</span>
                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: auto;" />
                                        <col style="width: 60px;" />
                                    </colgroup>
                                    <tr>
                                        <th>내용</th>
                                        <th>삭제</th>
                                    </tr>
                                    <tr v-for="(data, index) in commentList" :key="index">
                                        <td style="text-align: right;">
                                            <pre class="force-left">{{ data.content }}</pre>
                                            <span class="small-font force-right">
                                                {{ data.name }} | {{ data.regDt | formatTime }}
                                            </span>
                                        </td>
                                        <td>
                                            <button
                                                v-if="data.memberId === memberId"
                                                class="btn btn-delete2"
                                                @click="deleteComment(data.id)"
                                            >
                                                <span>삭제</span>
                                            </button>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <!-- // content-wrap -->
    </div>
    <!-- // wrap -->
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ApprovalApi from '../../api/ApprovalApi';
import FacemappingApi from '../../api/FacemappingApi';
import { formatTime } from '../../utils/date';
import { MEMBER_ID, TYPE } from './../../const';
export default {
    name: 'Detail',
    components: {},
    data: () => {
        return {
            id: null,
            data: {
                constructionNameValue: '--'
            },
            sectionList: [],
            faceMappingSection: {},
            faceMappingStrength: {},
            groundWaterRatio: {},
            rmr: 0,
            approvalList: [],
            isCloseE: false,
            isCloseA: false,
            isCloseB: false,
            isCloseC: false,
            isCloseD: false,
            isSignBtn: false,
            isSignCancelBtn: false,
            authType: 'observer',
            memberId: '',
            confirmParam: {
                msg: '',
                isShow: false,
                callbackParam: {}
            },
            commentList: [],
            comment: ''
        };
    },
    computed: {
        ...mapState({})
    },
    beforeCreate() {
        ///////////////////////
        // Initializer Area
        ///////////////////////
        //this.showLoading();
        //this.$store.dispatch('showLoading');
    },
    created() {
        this.id = this.$route.params.id;
    },
    mounted() {
        this.memberId = localStorage.getItem(MEMBER_ID);
        this.authType = localStorage.getItem(TYPE);
        this.dataObj();
    },
    beforeDestroy() {},
    methods: {
        ...mapActions(['showLoading', 'hideLoading']),
        backbtn() {
            this.$router.go(-1);
        },
        home() {
            this.$router.push({
                name: 'Main'
            });
        },
        dataObj() {
            this.showLoading();
            this.isSignBtn = false;
            this.isSignCancelBtn = false;

            ApprovalApi.getLine(this.id).then(res => {
                this.approvalList = res.content;

                const waitingList = this.approvalList.filter(item => item.status === 'waiting');
                const approvalList = this.approvalList.filter(item => item.status === 'approval');

                if (waitingList.length > 0) {
                    if (waitingList[0].memberId === this.memberId) {
                        this.isSignBtn = true;
                    }
                }

                if (approvalList.length > 0) {
                    if (approvalList[approvalList.length - 1].memberId === this.memberId) {
                        this.isSignCancelBtn = true;
                    }
                }
            });

            FacemappingApi.detail(this.id).then(res => {
                this.data = res.content;
                console.log(this.data);

                if (this.data.faceMappingStrength) this.faceMappingStrength = res.content.faceMappingStrength;
                var sectionList = res.content.faceMappingSectionList;

                if (sectionList && sectionList.length > 0) {
                    this.sectionList = sectionList[0];
                }

                this.hideLoading();
            });

            this.getCommentList();
        },
        displayType(rmrScore) {
            if (rmrScore >= 100) {
                return 1;
            } else if (rmrScore >= 81) {
                return 2;
            } else if (rmrScore >= 61) {
                return 3;
            } else if (rmrScore >= 41) {
                return 4;
            } else {
                return 5;
            }
        },
        waterScore() {
            if (this.faceMappingStrength.groundWaterRatioScore === 1) {
                return 15;
            } else if (this.faceMappingStrength.groundWaterRatioScore === 2) {
                return 10;
            } else if (this.faceMappingStrength.groundWaterRatioScore === 3) {
                return 7;
            } else if (this.faceMappingStrength.groundWaterRatioScore === 4) {
                return 4;
            } else {
                return 0;
            }
        },
        orientationScore() {
            if (this.faceMappingStrength.orientationScore === 1) {
                return 0;
            } else if (this.faceMappingStrength.orientationScore === 2) {
                return -2;
            } else if (this.faceMappingStrength.orientationScore === 3) {
                return -5;
            } else if (this.faceMappingStrength.orientationScore === 4) {
                return -10;
            } else if (this.faceMappingStrength.orientationScore === 5) {
                return -12;
            } else if (this.faceMappingStrength.orientationScore === 6) {
                return -5;
            } else {
                return -5;
            }
        },
        displayApproval(item) {
            let display = item.name;
            if (item.status === 'approval') {
                display += ' ' + formatTime(item.approvalDt);
            }
            return display;
        },
        signCancel() {
            //var callbackParam = {};
            if (confirm('서명을 취소 하시겠습니까?')) {
                ApprovalApi.cancelSign(this.id).then(() => {
                    this.dataObj();
                });
            }
        },
        sign() {
            if (confirm('서명 하시겠습니까?')) {
                var param = {
                    masterId: this.id,
                    status: 'approval',
                    approvalMsg: null
                };

                ApprovalApi.sign(param).then(() => {
                    this.dataObj();
                });
            }
        },
        deleteComment(id) {
            if (confirm('댓글을 삭제 하시겠습니까?')) {
                FacemappingApi.deleteComment(id).then(() => {
                    this.getCommentList();
                });
            }
        },
        addComment() {
            if (confirm('댓글을 등록 하시겠습니까?')) {
                console.log(this.id);
                var param2 = {
                    masterId: this.id,
                    content: this.comment,
                    id: null
                };

                console.log(param2);

                FacemappingApi.postComment(param2).then(() => {
                    this.comment = '';
                    this.getCommentList();
                });
            }
        },
        getCommentList() {
            FacemappingApi.getCommentList(this.id).then(res => {
                this.commentList = res.content;
            });
        }
    }
};
</script>
